import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { priceListSalesman, priceListSalesmanType } from '../../types/slices/priceListSalesmanType'

const initialState: priceListSalesmanType =
{
    status: ApiStatus.FETCHED,
    priceListSalesman: [],
    priceListSelectedSalesman: {} as priceListSalesman,
    errorMessage: undefined,
    action: ''
}

const priceListSalesmanSlice = createSlice({
    name: 'priceListSalesmanSlice',
    initialState,
    reducers: {
        onFetchPriceListSalesman (state, { payload }: { payload: priceListSalesman[]}) {
            state.status = ApiStatus.FETCHED
            state.priceListSalesman = payload
            state.errorMessage = undefined
        },
        onSetSelectedPriceListSalesman (state, { payload }: { payload: priceListSalesman }) {
            state.priceListSelectedSalesman = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectPriceListSalesmanState = (state: RootState) => state.priceListSalesmanSlice
export default priceListSalesmanSlice.reducer
export const {
    onFetchPriceListSalesman,
    onSetSelectedPriceListSalesman,
    changeStatus,
    setAction,
} = priceListSalesmanSlice.actions
